export default {
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 16
    },
    '@media (max-width:599.95px)': {
      padding: 12,
      '&:last-child': {
        paddingBottom: 12
      }
    }
  }
};
